import { render, staticRenderFns } from "./FacilityInfoWin.vue?vue&type=template&id=3124533c&"
import script from "./FacilityInfoWin.vue?vue&type=script&lang=js&"
export * from "./FacilityInfoWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports